/**
 * 問題答覆記錄 - 執行動作
 */
export enum ServiceLogOperation {
  /** 提問 */
  Q = '提問',
  /** 設定 */
  S = '設定',
  /** 答覆 */
  A = '答覆',
  /** 轉發 */
  F = '轉發',
  /** 已解決 */
  SOLVED = '已解決'
}
